class Domain {
	constructor({
		id,
		organizations,
		name,
		verification_status: status,
		verification_attributes: verification
	} = {}) {
		this._id = id;
		this._organizations = organizations || [];
		this._name = name || '';
		this._status = status || 'failed';
		this._verification = verification || '';
	}

	getId = () => this._id;

	getKey = () => String(this._name);

	getName = () => this._name;

	getStatus = () => this._status;

	getStatusColor = () => {
		switch (this._status) {
		case 'success':
			return "green";
		case 'pending':
			return "orange";
		default:
			return "red";
		}
	};

	getOrganizations = () => this._organizations;

	getCredentials = () => {
		const result = [];
		const data = this._verification.replace(/\n/g,' ').split(' ');
		if(data.length % 3 === 0) {
			// Re arrange data to better display
			for(let i = 0; i < data.length ; i = i + 3) {
				result.push({
					type: data[i],
					value: data[i+2],
					name: data[i+1]
				});
			}
		}
		return result;
	}
}

export default Domain;
